import * as React from 'react';

import { noop } from 'lodash';

import type EntityContext from 'common/constants/entityContexts';
import type Permissions from 'common/constants/permissions';

import type { PermissionScope, PermissionsQueryVariables } from './queries';

export type PermissionsSubscription = {
  permissionNames?: Permissions[];
  context?: EntityContext;
  entityId?: string;
};

export type PermissionsContext = {
  permissions: PermissionScope[];
  subscriptionsLoading?: Map<string, boolean>;
  loading: boolean;
  variables?: PermissionsQueryVariables;
  registerPermissions: (subscription: PermissionsSubscription) => string;
  unregisterPermissions: (subscriptionId: string) => void;
};

const context = React.createContext<PermissionsContext>({
  permissions: [],
  subscriptionsLoading: undefined,
  loading: false,
  registerPermissions: () => '',
  unregisterPermissions: noop,
  variables: undefined,
});

export default context;
